const React = require("react");
const T = React.PropTypes;

const CubeIcon = React.createClass({
    props: {
        SizePx: T.number,
        TopPx: T.number,
        Color: T.string,
        style: T.object
    },
    getDefaultProps() {
        return {
            TopPx: 0,
            SizePx: 80,
            Color: "#fff"
        }
    },
    render() {
        const style = Object.assign({}, {
            position: "relative",
            top: this.props.TopPx,
            margin: "-21px -18px"
        }, this.props.style);

        const svg = (<svg version="1.1" id="Layer_1" style={style}
                          x="0px" y="0px"
                          width={this.props.SizePx} height={this.props.SizePx}
                          viewBox="0 0 612 792" enableBackground="new 0 0 612 792">
            <path fill={this.props.Color}
                  d="M342.144,182.346L87.445,250.158v271.728l184.123,87.827l252.986-67.556V271.178L342.144,182.346z
                    M166.049,519.462l87.512-23.473v65.215L166.049,519.462z M123.489,287.577l130.073,62.84v108.276l-130.073,34.882V287.577z
                    M446.815,273.398l-86.667,23.271v-65.47L446.815,273.398z M324.123,343.655v96.114l-34.532,9.262v-96.104L324.123,343.655z
                    M273.366,319.977l-109.455-52.887l160.212-42.654v81.91L273.366,319.977z M289.591,567.609V486.33l50.725-13.605l108.075,52.479
                    L289.591,567.609z M360.148,442.312V333.979l128.356-34.474v205.131L360.148,442.312z" />
        </svg>);

        return svg;
    }
});

module.exports = CubeIcon;


// WEBPACK FOOTER //
// ./src/components/CubeIcon/CubeIcon.jsx